import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { apiEndpoints } from '../../services/apiConfig';

// Async thunk for contact us API
export const submitContactUs = createAsyncThunk(
    'contactUs/submit',
    async (contactData, { rejectWithValue }) => {
        try {
            const response = await axios.post(apiEndpoints.contactUs, contactData);
            return response.data;

        } catch (error) {
            return rejectWithValue(
                error.response?.data?.meta?.note || 'Something went wrong'
            );
        }
    }
);

// Initial state
const initialState = {
    loading: false,
    success: false,
    error: null,
    data: null,
};

// Slice
const contactUsSlice = createSlice({
    name: 'contactUs',
    initialState,
    reducers: {
        resetContactUsState: () => initialState, // resets the state
    },
    extraReducers: (builder) => {
        builder
            .addCase(submitContactUs.pending, (state) => {
                state.loading = true;
                state.success = false;
                state.error = null;
            })
            .addCase(submitContactUs.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.data = action.payload;
            })
            .addCase(submitContactUs.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.error = action.payload;
            });
    },
});

export const { resetContactUsState } = contactUsSlice.actions;
export default contactUsSlice.reducer;
